import React, { useEffect, useState } from "react";

import { DasboardService } from "../Services/DashboardService";

const TableData = () => {
  const [teams, setTeams] = useState([]);
  const [selectedTeamId, setSelectedTeamId] = useState("");
  const [selectedTeamName, setSelectedTeamName] = useState("");


  const userData = JSON.parse(localStorage.getItem("userData"));
  const userRole = userData?.user?.role;
  console.log(`role: ${userRole}`);
  const teamName = userData?.teamId || [];
  const [data, setData] = useState({
    siteVisit: { upcoming: 0, completed: 0, noUpdates: 0 },
    booked: { upcoming: 0, completed: 0, noUpdates: 0 },
    registered: { upcoming: 0, completed: 0, noUpdates: 0 },
  });
  const bodTeamId = userData?.teamId?.[0]?.id;

 
  useEffect(() => {
    const fetchData = async (selectedTeamId) => {
      try {
        console.log(`in:${userRole}`);
        const response = await DasboardService.fetchDealForToday(
          userRole,
          selectedTeamId,
          bodTeamId
        );
        setData(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData(selectedTeamId);
  }, [selectedTeamId]);
  
  useEffect(() => {
    const storedTeams = userData?.teamId || [];
    setTeams(storedTeams);

    if (userRole === "MD" && storedTeams.length > 0) {
      setSelectedTeamId(storedTeams[0].id);
      setSelectedTeamName(storedTeams[0].name);

    }
  }, [userRole]);

  const handleTeamChange = (event) => {

    teams.forEach((item) =>{
if(item.id ===event.target.value){
  setSelectedTeamName(item.name)
}

    })
    setSelectedTeamId(event.target.value);
    // setSelectedTeamName(event.target.value);
    

    // fetchDealForDayCounts(event.target.value);
  };

  return (
    <>

      {/* <div> */}
      {(userRole === "BOD" || userRole === "MD") && (
        <div className={`${userRole === "BOD" ? "mt-10" : userRole === "MD" ? "" : ""} h-12 shadow-md rounded-t-md flex  items-center justify-between px-4 bg-white`}>
          {userRole === "BOD" && (
            <div className="text-black  capitalize text-lg font-bold">
              Team:
              <span className="text-customGreen ml-1 font-normal">
                {teamName[0].name}{" "}
              </span>
            </div>
          )}
          {userRole === "MD" && (
            <div className="text-black capitalize text-lg font-bold">
              Team:
              <span className="text-customGreen ml-1 font-normal">
                {selectedTeamName}{" "}
              </span>
            </div>
          )}

          {userRole === "MD" && (
            <select
              id="teamSelect"
              value={selectedTeamId}
              onChange={handleTeamChange}
              className=" block w-56 capitalize py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"

              // className=" block w-20 h-8 py-2 px-3  bg-white   text-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            >
              {teams.map((team) => (
                <option key={team.id} value={team.id}>
                  {team.name}
                </option>
              ))}
            </select>
          )}
        </div>
      )}
      {/* </div> */}

      <table className="  shadow-md w-full xl:text-lg custom-xl:text-xl 3xl:text-2xl 4xl:text-3xl rounded-lg text-center   bg-white border-collapse lg:text-sm">
        <thead>
          <tr className="whitespace-nowrap">
            <th className="border-r-2 border-t-2 border-slate-400 p-4 bg-customGreen text-white">
              Today
            </th>
            <th className="border-r-2 border-t-2 border-slate-400 p-4">
              Site Visit
            </th>
            <th className="border-r-2 border-t-2 border-slate-400 p-4">
              Booking
            </th>
            <th className="border-t-2 border-slate-400 p-4">Registration</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className=" border-t-2 border-r-2 border-slate-400 p-4">
              Upcoming
            </td>
            <td className="border-t-2 border-r-2 border-slate-400 p-4">
              {data.siteVisit?.upcoming ?? 0}
            </td>
            <td className="border-t-2 border-r-2 border-slate-400 p-4">
              {data.booked?.upcoming ?? 0}
            </td>
            <td className="border-t-2 border-slate-400 p-4">
              {data.registered?.upcoming ?? 0}
            </td>
          </tr>
          <tr>
            <td className=" border-t-2 border-r-2 border-slate-400 p-4">
              Completed
            </td>
            <td className="border-t-2 border-r-2 border-slate-400 p-4">
              {data.siteVisit?.completed ?? 0}
            </td>
            <td className="border-t-2 border-r-2 border-slate-400 p-4">
              {data.booked?.completed ?? 0}
            </td>
            <td className="border-t-2  border-slate-400 p-4">
              {data.registered?.completed ?? 0}
            </td>
          </tr>
          <tr>
            <td className="border-t-2 border-r-2 border-slate-400 p-4 text-red-600">
              No update
            </td>
            <td className="border-t-2 border-r-2 border-slate-400 p-4">
              {data.siteVisit?.noUpdates ?? 0}
            </td>
            <td className="border-t-2 border-r-2 border-slate-400 p-4">
              {data.booked?.noUpdates ?? 0}
            </td>
            <td className="border-t-2  border-slate-400 p-4">
              {data.registered?.noUpdates ?? 0}
            </td>
          </tr>
        </tbody>
      </table>
    </>
  );
};

export default TableData;


// import React, { useEffect, useState } from "react";
// import { Users, ChevronDown } from "lucide-react";

// import { DasboardService } from "../Services/DashboardService";

// const TableData = () => {
//   const [teams, setTeams] = useState([]);
//   const [selectedTeamId, setSelectedTeamId] = useState("");
//   const [selectedTeamName, setSelectedTeamName] = useState("");

//   const userData = JSON.parse(localStorage.getItem("userData"));
//   const userRole = userData?.user?.role;
//   console.log(`role: ${userRole}`);
//   const teamName = userData?.teamId || [];
//   const [data, setData] = useState({
//     siteVisit: { upcoming: 0, completed: 0, noUpdates: 0 },
//     booked: { upcoming: 0, completed: 0, noUpdates: 0 },
//     registered: { upcoming: 0, completed: 0, noUpdates: 0 },
//   });
//   const bodTeamId = userData?.teamId?.[0]?.id;

//   useEffect(() => {
//     const fetchData = async (selectedTeamId) => {
//       try {
//         console.log(`in:${userRole}`);
//         const response = await DasboardService.fetchDealForToday(
//           userRole,
//           selectedTeamId,
//           bodTeamId
//         );
//         setData(response.data);
//       } catch (error) {
//         console.error("Error fetching data:", error);
//       }
//     };
//     fetchData(selectedTeamId);
//   }, [selectedTeamId]);
  
//   useEffect(() => {
//     const storedTeams = userData?.teamId || [];
//     setTeams(storedTeams);

//     if (userRole === "MD" && storedTeams.length > 0) {
//       setSelectedTeamId(storedTeams[0].id);
//       setSelectedTeamName(storedTeams[0].name);
//     }
//   }, [userRole]);

//   const handleTeamChange = (event) => {
//     teams.forEach((item) => {
//       if (item.id === event.target.value) {
//         setSelectedTeamName(item.name);
//       }
//     });
//     setSelectedTeamId(event.target.value);
//   };

//   return (
//     <div className="space-y-4">
//       {/* Team Header */}
//       {(userRole === "BOD" || userRole === "MD") && (
//         <div className="bg-white rounded-lg shadow-sm border mt-12 p-4">
//           <div className="flex items-center justify-between">
//             <div className="flex items-center space-x-3">
//               <Users className="w-5 h-5 text-blue-600" />
//               <div>
//                 <span className="text-gray-600 text-sm">Team:</span>
//                 <span className="ml-2 font-semibold text-gray-900">
//                   {userRole === "BOD" ? teamName[0]?.name : selectedTeamName}
//                 </span>
//               </div>
//             </div>

//             {userRole === "MD" && (
//               <div className="relative">
//                 <select
//                   id="teamSelect"
//                   value={selectedTeamId}
//                   onChange={handleTeamChange}
//                   className="appearance-none bg-white border border-gray-300 rounded-md px-4 py-2 pr-8 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                 >
//                   {teams.map((team) => (
//                     <option key={team.id} value={team.id}>
//                       {team.name}
//                     </option>
//                   ))}
//                 </select>
//                 <ChevronDown className="absolute right-2 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" />
//               </div>
//             )}
//           </div>
//         </div>
//       )}

//       {/* Dashboard Table */}
//       <div className="bg-white rounded-lg shadow-sm border overflow-hidden">
//         <div className="bg-customGreen px-4 py-3">
//           <h2 className="text-white font-semibold">Today's Dashboard</h2>
//         </div>
        
//         <div className="overflow-x-auto">
//           <table className="w-full">
//             <thead className="bg-gray-50">
//               <tr>
//                 <th className="px-4 py-3 text-left font-medium text-gray-700 border-r">Status</th>
//                 <th className="px-4 py-3 text-center font-medium text-gray-700 border-r">Site Visit</th>
//                 <th className="px-4 py-3 text-center font-medium text-gray-700 border-r">Booking</th>
//                 <th className="px-4 py-3 text-center font-medium text-gray-700">Registration</th>
//               </tr>
//             </thead>
//             <tbody className="divide-y divide-gray-200">
//               <tr className="hover:bg-gray-50">
//                 <td className="px-4 py-3 font-medium text-gray-900 border-r">Upcoming</td>
//                 <td className="px-4 py-3 text-center border-r">
//                   <span className="inline-flex items-center justify-center w-8 h-8 bg-blue-100 text-blue-800 rounded-full font-semibold">
//                     {data.siteVisit?.upcoming ?? 0}
//                   </span>
//                 </td>
//                 <td className="px-4 py-3 text-center border-r">
//                   <span className="inline-flex items-center justify-center w-8 h-8 bg-blue-100 text-blue-800 rounded-full font-semibold">
//                     {data.booked?.upcoming ?? 0}
//                   </span>
//                 </td>
//                 <td className="px-4 py-3 text-center">
//                   <span className="inline-flex items-center justify-center w-8 h-8 bg-blue-100 text-blue-800 rounded-full font-semibold">
//                     {data.registered?.upcoming ?? 0}
//                   </span>
//                 </td>
//               </tr>
              
//               <tr className="hover:bg-gray-50">
//                 <td className="px-4 py-3 font-medium text-gray-900 border-r">Completed</td>
//                 <td className="px-4 py-3 text-center border-r">
//                   <span className="inline-flex items-center justify-center w-8 h-8 bg-green-100 text-green-800 rounded-full font-semibold">
//                     {data.siteVisit?.completed ?? 0}
//                   </span>
//                 </td>
//                 <td className="px-4 py-3 text-center border-r">
//                   <span className="inline-flex items-center justify-center w-8 h-8 bg-green-100 text-green-800 rounded-full font-semibold">
//                     {data.booked?.completed ?? 0}
//                   </span>
//                 </td>
//                 <td className="px-4 py-3 text-center">
//                   <span className="inline-flex items-center justify-center w-8 h-8 bg-green-100 text-green-800 rounded-full font-semibold">
//                     {data.registered?.completed ?? 0}
//                   </span>
//                 </td>
//               </tr>
              
//               <tr className="hover:bg-gray-50">
//                 <td className="px-4 py-3 font-medium text-red-600 border-r">No Updates</td>
//                 <td className="px-4 py-3 text-center border-r">
//                   <span className="inline-flex items-center justify-center w-8 h-8 bg-red-100 text-red-800 rounded-full font-semibold">
//                     {data.siteVisit?.noUpdates ?? 0}
//                   </span>
//                 </td>
//                 <td className="px-4 py-3 text-center border-r">
//                   <span className="inline-flex items-center justify-center w-8 h-8 bg-red-100 text-red-800 rounded-full font-semibold">
//                     {data.booked?.noUpdates ?? 0}
//                   </span>
//                 </td>
//                 <td className="px-4 py-3 text-center">
//                   <span className="inline-flex items-center justify-center w-8 h-8 bg-red-100 text-red-800 rounded-full font-semibold">
//                     {data.registered?.noUpdates ?? 0}
//                   </span>
//                 </td>
//               </tr>
//             </tbody>
//           </table>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default TableData;